'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SiteLogo = require('shared/components/SiteLogo/SiteLogo');

var _SiteLogo2 = _interopRequireDefault(_SiteLogo);

var _SiteTitle = require('shared/components/SiteTitle/SiteTitle');

var _SiteTitle2 = _interopRequireDefault(_SiteTitle);

var _SiteNavigation = require('shared/components/SiteNavigation/SiteNavigation');

var _SiteNavigation2 = _interopRequireDefault(_SiteNavigation);

var _SiteFooter = require('shared/components/SiteFooter/SiteFooter');

var _SiteFooter2 = _interopRequireDefault(_SiteFooter);

var _CustomizeMatch = require('shared/components/CustomizeMatch');

var _CustomizeMatch2 = _interopRequireDefault(_CustomizeMatch);

var _reactRouter = require('react-router');

var _intro = require('intro.js-react');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      if (_config.CLIENT) {
        require('shared/stylesheets/main.scss');

        require('shared/stylesheets/lib/_components.callouts.scss');
        require('shared/stylesheets/lib/_components.chart.scss');
        require('shared/stylesheets/lib/_components.columns.scss');
        require('shared/stylesheets/lib/_components.copyright.scss');
        require('shared/stylesheets/lib/_components.customizer.scss');
        require('shared/stylesheets/lib/_components.footer.scss');
        require('shared/stylesheets/lib/_components.header.scss');
        require('shared/stylesheets/lib/_components.hero.scss');
        require('shared/stylesheets/lib/_components.icons.scss');
        require('shared/stylesheets/lib/_components.map.scss');
        require('shared/stylesheets/lib/_components.matcher.scss');
        require('shared/stylesheets/lib/_components.quote.scss');
        require('shared/stylesheets/lib/_components.slides.scss');
        require('shared/stylesheets/lib/_components.tabs.scss');
        require('shared/stylesheets/lib/_components.textfields.scss');
        require('shared/stylesheets/lib/_components.tooltips.scss');

        require('shared/stylesheets/lib/_page.home.scss');
        require('shared/stylesheets/lib/_page.page.scss');
        require('shared/stylesheets/lib/_page.job.scss');
        require('shared/stylesheets/lib/_page.landing.scss');
        require('shared/stylesheets/lib/_page.subsector.scss');
        require('shared/stylesheets/lib/_page.employer.scss');
        require('shared/stylesheets/lib/_page.list.scss');
        require('shared/stylesheets/lib/_page.matching.scss');
        require('shared/stylesheets/lib/_page.notfound.scss');

        require('intro.js/introjs.css');
      }

      var _props = this.props,
          backgroundImage = _props.backgroundImage,
          classes = _props.classes,
          title = _props.title,
          headerHeadline = _props.headerHeadline,
          headerTagline = _props.headerTagline,
          headerTagline2 = _props.headerTagline2,
          logo = _props.logo,
          footer = _props.footer,
          navigation = _props.navigation,
          location = _props.location,
          route = _props.route;


      var getIsHomePage = function getIsHomePage(_ref) {
        var pathname = _ref.pathname;

        return pathname === '/';
      };

      var isHomePage = getIsHomePage(location);

      var appStyle = {
        backgroundImage: backgroundImage ? 'url(' + backgroundImage + ')' : ''
        // added this statement so I can see what I am testing.
        // There is a lot of white font over this background
      };

      var appClass = ['shfs'].concat(classes).join(' ');

      return _react2.default.createElement(
        'div',
        { className: appClass },
        _react2.default.createElement('div', { className: 'background', style: appStyle }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/' },
              _react2.default.createElement(_SiteLogo2.default, { logo: logo }),
              _react2.default.createElement(_SiteTitle2.default, {
                title: title,
                headerTagline: headerTagline,
                headerTagline2: headerTagline2,
                headerHeadline: headerHeadline
              })
            ),
            _react2.default.createElement(_SiteNavigation2.default, { links: navigation }),
            !isHomePage ? _react2.default.createElement(_CustomizeMatch2.default, null) : null
          )
        ),
        _react2.default.createElement(
          'main',
          { role: 'main' },
          this.props.children
        ),
        _react2.default.createElement(
          'footer',
          null,
          _react2.default.createElement(_SiteFooter2.default, { footer: footer })
        ),
        _react2.default.createElement(
          'div',
          { className: 'mobile-only' },
          _react2.default.createElement(_SiteNavigation2.default, { links: navigation })
        )
      );
    }
  }]);
  return App;
}(_react.Component);

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/App/App.jsx
// module id = 1143
// module chunks = 0